module.exports = __webpack_public_path__ + "static/media/U1-T2-1-2a.4384eefa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-1-2a.svg
// module id = 518
// module chunks = 0